import React, { useEffect } from 'react';
import { Card, Col, List, Row, Typography } from 'antd';
import { useSelector } from 'react-redux';
import InfiniteScrollList from '../../../components/Forms/ListView/InfiniteScrollList';

const { Text } = Typography;

interface Holiday {
    month: string;
    day: string;
    title: string;
    subtitle: string;
}

const HolidayCard: React.FC<Holiday> = ({ month, day, title, subtitle }) => (
    <div className="flex items-center p-2">
        <div className={`flex flex-col items-center justify-center w-16 h-16 rounded-md mb-2
      ${month === 'Dec' ? 'bg-purple-200 text-purple-800' :
                month === 'Nov' ? 'bg-orange-200 text-orange-800' :
                    month === 'Mar' ? 'bg-yellow-200 text-yellow-800' :
                        month === 'Aug' ? 'bg-purple-100 text-purple-700' :
                            'bg-gray-200 text-gray-800'}`}>
            <Text className="font-bold">{month}</Text>
            <Text>{day}</Text>
        </div>
        <div className="ml-4">
            <Text strong>{title}</Text>
            <br />
            <Text type="secondary" className="text-sm w-100" ellipsis={true}>{subtitle}</Text>
        </div>
    </div>
);

const HolidayList: React.FC = () => {
    const { user } = useSelector((state: any) => state.app);

    return (
        <Row gutter={[16, 16]} style={{ margin: 24 }} className="w-full">
            <InfiniteScrollList
                listProps={{ style: { width: '100%' } }}
                apiUrl={`/holiday/${user?.holidayList?._id}`}
                renderItem={(holiday) => (
                    <List.Item className="holiday-item" style={{ padding: 0 }}>
                        <Col span={24} key={holiday._id}>
                            <HolidayCard
                                month={new Date(holiday.holidayOn).toLocaleString('default', { month: 'short' })}
                                day={new Date(holiday.holidayOn).getDate().toString()}
                                title={holiday.name}
                                subtitle={holiday?.description || 'No description available'}
                            />
                        </Col>
                    </List.Item>
                )}
            />
        </Row>
    );
}

export default HolidayList;
